import axios from "axios";
import { useCallback } from "react";
import SideNavbar from "../../components/common/SideNavbar";
import TopNavbar from "../../components/common/TopNavbar";
import { useEffect, useState, useRef } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import DataTable from "react-data-table-component";
import { vesselScheduleTableCustomStyles } from "../../utils/TableCustomStyles";
import Select from "react-select";
import { PortSequenceSelectCustomStyles } from "../../utils/SelectCustomStyles";
import { Stepper, Step } from "react-form-stepper";
import "../../components/css/StepperForm.css";

function VesselScheduleMaster() {
  const steps = ["Schedule Details", "Timeline"];
  const [activeStep, setActiveStep] = useState(0);

  const addform = useRef(null);
  const updateform = useRef(null);
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [dataPending, setDataPending] = useState(true);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] =
    useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const user_id = sessionStorage["id"];
  const user_role = sessionStorage["userrole"];
  const [loggedInUser, setLoggedInUser] = useState(null);

  // -------------------------- Add ----------------------
  const [vesselName, setVesselName] = useState(null);
  const [voyage, setVoyage] = useState("");
  const [imNumber, setIMNumber] = useState("");
  const [imDate, setIMDate] = useState("");
  const [imoCode, setImoCode] = useState("");
  const [callSign, setCallSign] = useState("");
  const [lineCode, setLineCode] = useState("");
  const [lineIgmNumber, setLineIGMNumber] = useState("");
  const [lineIgmDate, setLineIGMDate] = useState("");
  const [reserved20Ft, setReserved20Ft] = useState("");
  const [reserved40Ft, setReserved40Ft] = useState("");
  const [maxTonnage, setMaxTonnage] = useState("");
  const [tba, setTba] = useState("off");

  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [vesselPorts, setVesselPorts] = useState([]);

  const [showAddLoader, setShowAddLoader] = useState(false);
  const [vesselList, setVesselList] = useState([]);
  const [vesselServiceList, setVesselServiceList] = useState([]);
  const [vesselListLoading, setVesselListLoading] = useState(false);
  const [vesselServiceListLoading, setVesselServiceListLoading] =
    useState(false);
  const [vesselService, setVesselService] = useState(null);
  const [vesselTimeLineData, setVesselTimeLineData] = useState([]);

  const [canvasFullScreen, setCanvasFullScreen] = useState(false);

  // Add field errors
  const [showNameError, setShowNameError] = useState(false);
  const [showVoyageError, setShowVoyageError] = useState(false);
  const [showServiceError, setShowServiceError] = useState(false);
  const [showReserved20FtError, setShowReserved20FtError] = useState(false);
  const [showReserved40FtError, setShowReserved40FtError] = useState(false);
  const [showMaxTonnageError, setShowMaxTonnageError] = useState(false);

  // Add validation summary
  const [showValidationError, setShowValidationError] = useState(false);
  const [validationErrorArray, setValidationErrorArray] = useState([]);
  const [isValidationErrorVisible, setIsValidationErrorVisible] =
    useState(false);

  // -------------------------- Update ----------------------
  const [updateId, setUpdateId] = useState("");
  const [updateVesselName, setUpdateVesselName] = useState("");
  const [updateVoyage, setUpdateVoyage] = useState("");
  const [updateImNumber, setUpdateIMNumber] = useState("");
  const [updateImDate, setUpdateIMDate] = useState("");
  const [updateImoCode, setUpdateImoCode] = useState("");
  const [updateCallSign, setUpdateCallSign] = useState("");
  const [updateLineCode, setUpdateLineCode] = useState("");
  const [updateLineIgmNumber, setUpdateLineIGMNumber] = useState("");
  const [updateLineIgmDate, setUpdateLineIGMDate] = useState("");
  const [updateReserved20Ft, setUpdateReserved20Ft] = useState("");
  const [updateReserved40Ft, setUpdateReserved40Ft] = useState("");
  const [updateMaxTonnage, setUpdateMaxTonnage] = useState("");
  const [updateTba, setUpdateTba] = useState("off");

  const [showUpdateCanvas, setShowUpdateCanvas] = useState(false);
  const [updateVesselPorts, setUpdateVesselPorts] = useState([]);

  const [showUpdateLoader, setShowUpdateLoader] = useState(false);
  const [showDeleteLoader, setShowDeleteLoader] = useState(false);
  const [recordForDelete, setRecordForDelete] = useState("");

  const [updateVesselService, setUpdateVesselService] = useState(null);
  const [updateVesselTimeLineData, setUpdateVesselTimeLineData] = useState([]);

  // Update field errors
  const [showUpdateNameError, setShowUpdateNameError] = useState(false);
  const [showUpdateVoyageError, setShowUpdateVoyageError] = useState(false);
  const [showUpdateServiceError, setShowUpdateServiceError] = useState(false);
  const [showUpdateReserved20FtError, setShowUpdateReserved20FtError] =
    useState(false);
  const [showUpdateReserved40FtError, setShowUpdateReserved40FtError] =
    useState(false);
  const [showUpdateMaxTonnageError, setShowUpdateMaxTonnageError] =
    useState(false);

  // Update validation summary
  const [showUpdateValidationError, setShowUpdateValidationError] =
    useState(false);
  const [updateValidationErrorArray, setUpdateValidationErrorArray] = useState(
    [],
  );
  const [isUpdateValidationErrorVisible, setIsUpdateValidationErrorVisible] =
    useState(false);

  // ========== Validation Helpers ==========
  const isPositiveNumber = (val) =>
    val !== "" && !isNaN(val) && Number(val) >= 0 && !String(val).includes("-");

  const hasAnyAddError = () =>
    showNameError ||
    showVoyageError ||
    showServiceError ||
    showReserved20FtError ||
    showReserved40FtError ||
    showMaxTonnageError;

  const buildAddErrorMessages = (overrides = {}) => {
    const errors = [];
    const name = "vesselName" in overrides ? overrides.vesselName : vesselName;
    const v = "voyage" in overrides ? overrides.voyage : voyage;
    const service =
      "vesselService" in overrides ? overrides.vesselService : vesselService;
    const r20 =
      "reserved20Ft" in overrides ? overrides.reserved20Ft : reserved20Ft;
    const r40 =
      "reserved40Ft" in overrides ? overrides.reserved40Ft : reserved40Ft;
    const mt = "maxTonnage" in overrides ? overrides.maxTonnage : maxTonnage;
    if (!name) errors.push("Vessel Name is required");
    if (!v) errors.push("Voyage is required");
    if (!service) errors.push("Service is required");
    if (!r20) errors.push("Reserved 20Ft is required");
    else if (!isPositiveNumber(r20))
      errors.push("Reserved 20Ft must be a positive number");
    if (!r40) errors.push("Reserved 40Ft is required");
    else if (!isPositiveNumber(r40))
      errors.push("Reserved 40Ft must be a positive number");
    if (!mt) errors.push("Max Tonnage is required");
    else if (!isPositiveNumber(mt))
      errors.push("Max Tonnage must be a positive number");
    return errors;
  };

  const hasAnyUpdateError = () =>
    showUpdateNameError ||
    showUpdateVoyageError ||
    showUpdateServiceError ||
    showUpdateReserved20FtError ||
    showUpdateReserved40FtError ||
    showUpdateMaxTonnageError;

  const buildUpdateErrorMessages = (overrides = {}) => {
    const errors = [];
    const name =
      "updateVesselName" in overrides
        ? overrides.updateVesselName
        : updateVesselName;
    const v =
      "updateVoyage" in overrides ? overrides.updateVoyage : updateVoyage;
    const service =
      "updateVesselService" in overrides
        ? overrides.updateVesselService
        : updateVesselService;
    const r20 =
      "updateReserved20Ft" in overrides
        ? overrides.updateReserved20Ft
        : updateReserved20Ft;
    const r40 =
      "updateReserved40Ft" in overrides
        ? overrides.updateReserved40Ft
        : updateReserved40Ft;
    const mt =
      "updateMaxTonnage" in overrides
        ? overrides.updateMaxTonnage
        : updateMaxTonnage;
    if (!name) errors.push("Vessel Name is required");
    if (!v) errors.push("Voyage is required");
    if (!service) errors.push("Service is required");
    if (!r20) errors.push("Reserved 20Ft is required");
    else if (!isPositiveNumber(r20))
      errors.push("Reserved 20Ft must be a positive number");
    if (!r40) errors.push("Reserved 40Ft is required");
    else if (!isPositiveNumber(r40))
      errors.push("Reserved 40Ft must be a positive number");
    if (!mt) errors.push("Max Tonnage is required");
    else if (!isPositiveNumber(mt))
      errors.push("Max Tonnage must be a positive number");
    return errors;
  };

  const handleCheckValidationClick = () =>
    setIsValidationErrorVisible(!isValidationErrorVisible);

  const handleUpdateCheckValidationClick = () =>
    setIsUpdateValidationErrorVisible(!isUpdateValidationErrorVisible);

  // ========== API calls ==========
  const getLoggenInUser = useCallback(async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/user/" + user_id,
      );
      if (response) {
        setLoggedInUser(response.data);
      }
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    }
  }, [user_id]);

  const getVesselSchedule = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/master/vesselschedule/",
      );
      if (response) {
        const schedule_data = response.data;
        const sorted_data = schedule_data.sort(
          (a, b) => a.eta_date - b.eta_date,
        );
        setData(sorted_data);
        setDataPending(false);
      }
    } catch (err) {
      toast.error("Error in fetching vessel schedule data! Try again.");
    }
  };

  const getVessel = async () => {
    try {
      setVesselListLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/master/vessel/",
      );
      if (response) {
        const data = response.data
          ?.sort((a, b) => a.name.localeCompare(b.name))
          .map((item) => ({ value: item.id, label: item.name }));
        setVesselList(data);
      }
      setVesselListLoading(false);
    } catch (err) {
      toast.error("Error in fetching vessel data! Try again.");
    }
  };

  const getVesselService = async () => {
    try {
      setVesselServiceListLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/master/vesselservice/",
      );
      if (response) {
        const service_data = response.data.map((service) => {
          const ports = service.sequence;
          const port_sequence = Object.values(ports)
            .sort((a, b) => a.index - b.index)
            .map((p) => p.name)
            .join(" → ");

          return {
            value: service.id,
            label: service.name + " : " + port_sequence,
          };
        });
        setVesselServiceList(service_data);
      }
      setVesselServiceListLoading(false);
    } catch (err) {
      toast.error("Error in fetching vessel service data! Try again.");
    }
  };

  const getCurrentUserRolePermission = async (roles) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/role/getuserrolepermission?roles=" +
          roles,
      );

      const role_permissions_array = [];
      for (let i = 0; i < response.data.length; i++) {
        for (let j = 0; j < response?.data[i]?.permissions_array.length; j++) {
          if (
            !role_permissions_array.includes(
              response?.data[i]?.permissions_array?.[j],
            )
          ) {
            role_permissions_array.push(
              response?.data[i]?.permissions_array?.[j],
            );
          }
        }
      }

      if (role_permissions_array) {
        setCurrentUserRolePermissionData(role_permissions_array);
      }
    } catch (err) {
      toast.error("Error in fetching user role data! Try again.");
    }
  };

  useEffect(() => {
    getVesselSchedule();
    getVessel();
    getVesselService();
    getLoggenInUser();
  }, [getLoggenInUser]);

  useEffect(() => {
    getCurrentUserRolePermission(user_role);
  }, [user_role]);

  // ========== Delete handlers ==========
  const handleDeleteModalClose = () => {
    setShowDeleteModal(false);
  };

  const handleDeleteModalOpen = (data) => {
    setRecordForDelete(data.id);
    setShowDeleteModal(true);
  };

  const deleteVesselSchedule = async (id) => {
    setShowDeleteLoader(true);
    try {
      await axios.delete(
        process.env.REACT_APP_BACKEND_API_URL +
          "/master/vesselschedule/" +
          id +
          "/",
      );
      getVesselSchedule();
      toast.success("Record deleted successfully");
    } catch (err) {
      toast.error("Error in deleting record! Try again.");
    } finally {
      setShowDeleteLoader(false);
      setShowDeleteModal(false);
    }
  };

  // ========== Add logic ==========
  const resetAddForm = () => {
    setVesselName(null);
    setVoyage("");
    setVesselService(null);
    setIMNumber("");
    setIMDate("");
    setImoCode("");
    setCallSign("");
    setLineCode("");
    setLineIGMNumber("");
    setLineIGMDate("");
    setReserved20Ft("");
    setReserved40Ft("");
    setMaxTonnage("");
    setTba("off");
    setVesselPorts([]);
    setVesselTimeLineData([]);
    setShowNameError(false);
    setShowVoyageError(false);
    setShowServiceError(false);
    setShowReserved20FtError(false);
    setShowReserved40FtError(false);
    setShowMaxTonnageError(false);
    setShowValidationError(false);
    setValidationErrorArray([]);
    setIsValidationErrorVisible(false);
    setActiveStep(0);
  };

  const handleAddModalClose = () => {
    resetAddForm();
    setShowAddCanvas(false);
    setCanvasFullScreen(false);
  };

  const addVesselSchedule = async (e) => {
    e.preventDefault();

    setShowNameError(!vesselName);
    setShowVoyageError(!voyage);
    setShowServiceError(!vesselService);
    setShowReserved20FtError(!reserved20Ft || !isPositiveNumber(reserved20Ft));
    setShowReserved40FtError(!reserved40Ft || !isPositiveNumber(reserved40Ft));
    setShowMaxTonnageError(!maxTonnage || !isPositiveNumber(maxTonnage));
    setValidationErrorArray(buildAddErrorMessages());

    if (
      !vesselName ||
      !voyage ||
      !vesselService ||
      !reserved20Ft ||
      !isPositiveNumber(reserved20Ft) ||
      !reserved40Ft ||
      !isPositiveNumber(reserved40Ft) ||
      !maxTonnage ||
      !isPositiveNumber(maxTonnage)
    ) {
      setShowValidationError(true);
      return;
    }

    setShowAddLoader(true);

    const data = {
      vessel: vesselName?.value,
      voyage: voyage,
      service: vesselService?.value,
      im_number: imNumber,
      im_date: imDate || null,
      imo_code: imoCode,
      call_sign: callSign,
      line_code: lineCode,
      line_igm_number: lineIgmNumber,
      line_igm_date: lineIgmDate || null,
      dead_freight_20ft: reserved20Ft,
      dead_freight_40ft: reserved40Ft,
      max_tonnage: maxTonnage,
      tba: tba,
      schedule_timeline: vesselTimeLineData,
      created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    try {
      const response = await axios.post(
        process.env.REACT_APP_BACKEND_API_URL + "/master/vesselschedule/",
        data,
        {
          headers: { "content-type": "application/json" },
        },
      );
      if (response.status === 201) {
        toast.success("New Vessel Schedule Created Successfully");
        resetAddForm();
        getVesselSchedule();
      }
    } catch (err) {
      toast.error("Error creating vessel schedule! Try again.");
    } finally {
      setShowAddLoader(false);
    }
  };

  // ========== Update logic ==========
  const resetUpdateForm = () => {
    setUpdateId("");
    setUpdateVesselName(null);
    setUpdateVoyage("");
    setUpdateVesselService(null);
    setUpdateIMNumber("");
    setUpdateIMDate("");
    setUpdateImoCode("");
    setUpdateCallSign("");
    setUpdateLineCode("");
    setUpdateLineIGMNumber("");
    setUpdateLineIGMDate("");
    setUpdateReserved20Ft("");
    setUpdateReserved40Ft("");
    setUpdateMaxTonnage("");
    setUpdateTba("off");
    setUpdateVesselPorts([]);
    setUpdateVesselTimeLineData([]);
    setShowUpdateNameError(false);
    setShowUpdateVoyageError(false);
    setShowUpdateServiceError(false);
    setShowUpdateReserved20FtError(false);
    setShowUpdateReserved40FtError(false);
    setShowUpdateMaxTonnageError(false);
    setShowUpdateValidationError(false);
    setUpdateValidationErrorArray([]);
    setIsUpdateValidationErrorVisible(false);
    setActiveStep(0);
  };

  const handleUpdateModalClose = () => {
    resetUpdateForm();
    setShowUpdateCanvas(false);
    setCanvasFullScreen(false);
  };

  const setUpdateVesselScheduleData = (data) => {
    setUpdateId(data?.id);
    setUpdateVesselName({
      value: data?.vessel_data?.id,
      label: data?.vessel_data?.name,
    });
    setUpdateVoyage(data?.voyage);
    setUpdateVesselService({
      value: data?.service_data?.id,
      label: data?.service_data?.name,
    });
    setUpdateIMNumber(data?.im_number);
    setUpdateIMDate(data?.im_date);
    setUpdateImoCode(data?.imo_code);
    setUpdateCallSign(data?.call_sign);
    setUpdateLineCode(data?.line_code);
    setUpdateLineIGMNumber(data?.line_igm_number);
    setUpdateLineIGMDate(data?.line_igm_date);
    setUpdateReserved20Ft(data?.dead_freight_20ft);
    setUpdateReserved40Ft(data?.dead_freight_40ft);
    setUpdateMaxTonnage(data?.max_tonnage);
    setUpdateTba(data?.tba);

    if (data?.schedule_timeline.length > 0) {
      setUpdateVesselPorts(data?.schedule_timeline);
    } else {
      handleUpdateVesselPorts({
        value: data?.service_data?.id,
        label: data?.service_data?.name,
      });
    }

    const port_sequence = Object.values(data?.service_data?.sequence);
    setUpdateVesselTimeLineData(data?.schedule_timeline);
    setActiveStep(0);
  };

  const updateVesselSchedule = async (e) => {
    e.preventDefault();

    setShowUpdateNameError(!updateVesselName);
    setShowUpdateVoyageError(!updateVoyage);
    setShowUpdateServiceError(!updateVesselService);
    setShowUpdateReserved20FtError(
      !updateReserved20Ft || !isPositiveNumber(updateReserved20Ft),
    );
    setShowUpdateReserved40FtError(
      !updateReserved40Ft || !isPositiveNumber(updateReserved40Ft),
    );
    setShowUpdateMaxTonnageError(
      !updateMaxTonnage || !isPositiveNumber(updateMaxTonnage),
    );
    setUpdateValidationErrorArray(buildUpdateErrorMessages());

    if (
      !updateVesselName ||
      !updateVoyage ||
      !updateVesselService ||
      !updateReserved20Ft ||
      !isPositiveNumber(updateReserved20Ft) ||
      !updateReserved40Ft ||
      !isPositiveNumber(updateReserved40Ft) ||
      !updateMaxTonnage ||
      !isPositiveNumber(updateMaxTonnage)
    ) {
      setShowUpdateValidationError(true);
      return;
    }

    setShowUpdateLoader(true);

    const id = updateId;
    const data = {
      id: id,
      vessel: updateVesselName?.value,
      voyage: updateVoyage,
      service: updateVesselService?.value,
      im_number: updateImNumber,
      im_date: updateImDate || null,
      imo_code: updateImoCode,
      call_sign: updateCallSign,
      line_code: updateLineCode,
      line_igm_number: updateLineIgmNumber,
      line_igm_date: updateLineIgmDate || null,
      dead_freight_20ft: updateReserved20Ft,
      dead_freight_40ft: updateReserved40Ft,
      max_tonnage: updateMaxTonnage,
      tba: updateTba,
      schedule_timeline: updateVesselTimeLineData,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL +
          "/master/vesselschedule/" +
          id +
          "/",
        data,
        {
          headers: { "content-type": "application/json" },
        },
      );
      if (response.status === 200) {
        toast.success("Vessel Schedule Updated Successfully");
        getVesselSchedule();
      }
    } catch (err) {
      toast.error("Error updating vessel schedule! Try again.");
    } finally {
      setShowUpdateLoader(false);
    }
  };

  // ========== Port / Timeline handlers ==========
  const handleVesselPorts = async (e) => {
    if (e?.value) {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/master/vesselservice/" +
          e?.value,
      );
      if (response) {
        setVesselPorts(Object.values(response.data?.sequence));

        const vessel_ports = Object.values(response.data?.sequence);

        setVesselTimeLineData(
          vessel_ports.map((port) => ({
            index: port.index,
            name: port.name,
            terminal_id: port.terminal_id,
            terminal_name: port.terminal_name,
            eta: "",
            etd: "",
            gate_open: "",
            cut_off: "",
          })),
        );
      }
    }
  };

  const handleUpdateVesselPorts = async (e) => {
    if (e?.value) {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/master/vesselservice/" +
          e?.value,
      );
      if (response) {
        setUpdateVesselPorts(Object.values(response.data?.sequence));

        const vessel_ports = Object.values(response.data?.sequence);

        setUpdateVesselTimeLineData(
          vessel_ports.map((port) => ({
            index: port.index,
            name: port.name,
            terminal_id: port.terminal_id,
            terminal_name: port.terminal_name,
            eta: port.eta,
            etd: port.etd,
            gate_open: port.gate_open,
            cut_off: port.cut_off,
          })),
        );
      }
    }
  };

  const handleChange = (index, field, value) => {
    const updated = [...vesselTimeLineData];
    updated[index][field] = value;
    setVesselTimeLineData(updated);
  };

  const handleUpdateChange = (index, field, value) => {
    const updated = [...updateVesselTimeLineData];
    updated[index][field] = value;
    setUpdateVesselTimeLineData(updated);
    setUpdateVesselPorts(updated);
  };

  function handleDataFromTopNavBar(permissiondata) {
    setDataFromTopNavBar(permissiondata);
  }

  // ========== Table columns ==========
  const columns = [
    {
      name: "Vessel",
      selector: (row) => row.vessel_data?.name,
      width: "250px",
      sortable: true,
    },
    {
      name: "Voyage",
      selector: (row) => row.voyage,
      width: "100px",
      sortable: true,
    },
    {
      name: "Service",
      selector: (row) => (
        <>
          {Object.values(row.service_data.sequence).map((port, i) => (
            <span key={i}>
              {i !== 0 ? " → " : ""}
              <b>{port.name}</b>
            </span>
          ))}
        </>
      ),
      wrap: true,
      width: "430px",
      sortable: true,
    },
    {
      name: "Reserved Slot",
      selector: (row) => (
        <>
          <span>
            <b>20Ft:</b> {row.dead_freight_20ft}
          </span>
          <br />
          <span>
            <b>40Ft:</b> {row.dead_freight_40ft}
          </span>
        </>
      ),
      width: "100px",
      sortable: true,
    },
    {
      name: "Max Tonnage",
      selector: (row) => row.max_tonnage + " MT",
      width: "100px",
      sortable: true,
    },
    {
      name: "IM Details",
      selector: (row) => (
        <>
          <span>
            <b>IM Number:</b> {row.im_number}
          </span>
          <br />
          <span>
            <b>IM Date:</b> {row.im_date}
          </span>
          <br />
          <span>
            <b>IMO Code:</b> {row.imo_code}
          </span>
        </>
      ),
      width: "170px",
      sortable: true,
    },
    {
      name: "Call Sign",
      selector: (row) => row.call_sign,
      width: "100px",
      sortable: true,
    },
    {
      name: "Line Details",
      selector: (row) => (
        <>
          <span>
            <b>Line Code:</b> {row.line_code}
          </span>
          <br />
          <span>
            <b>Line IGM Number:</b> {row.line_igm_number}
          </span>
          <br />
          <span>
            <b>Line IGN Date:</b> {row.line_igm_date}
          </span>
        </>
      ),
      width: "200px",
      sortable: true,
    },
    {
      name: "Action",
      center: true,
      width: "110px",
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes(
            "master:vesselschedule:update",
          ) ? (
            <Button
              className="btn btn-sm btn-inox-green border-0"
              title="Update"
              data-bs-toggle="offcanvas"
              data-bs-target="#updateSection"
              onClick={() => setUpdateVesselScheduleData(row)}
            >
              <i className="fa fa-edit"></i>
            </Button>
          ) : (
            ""
          )}

          {currentUserRolePermissionData?.includes(
            "master:vesselschedule:delete",
          ) ? (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => handleDeleteModalOpen(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          ) : (
            ""
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="page-content-bg">
      <ToastContainer></ToastContainer>
      <TopNavbar
        sidebarCollapsed={menuDrawerShow}
        topNavbarStatic={true}
        sendDataToParent={handleDataFromTopNavBar}
      />
      <SideNavbar
        sidebarCollapsed={menuDrawerShow}
        activeMenu="Master"
        activeSubMenu="VesselScheduleMaster"
        activeSubMenuLevel1=""
        permissionFromTopNavbar={dataFromTopNavBar}
      />

      <div
        className={
          menuDrawerShow
            ? "row main-content-collapsed text-left py-0"
            : "row main-content text-left py-0"
        }
      >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-6 py-1">
              <Button
                className="btn btn-sm btn-inox-green border-0 mx-2"
                onClick={() => setMenuDrawerShow(!menuDrawerShow)}
              >
                {menuDrawerShow ? (
                  <span>
                    <i className="fa fa-chevron-left mx-1"></i>
                  </span>
                ) : (
                  <span>
                    <i className="fa fa-chevron-right mx-1"></i>
                  </span>
                )}
              </Button>
              <span className="page-header-text">Vessel Schedule Master</span>
            </div>

            <div className="col-6 py-1" style={{ paddingRight: 30 }}>
              {currentUserRolePermissionData?.includes(
                "master:vesselschedule:add",
              ) ? (
                <Button
                  className="btn btn-sm btn-inox-green border-0 px-3 float-right"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#addSection"
                >
                  <i
                    className="fa fa-plus fa-lg text-right"
                    style={{ paddingRight: 10 }}
                  ></i>
                  <span className="fw-bold">Add Vessel Schedule</span>
                </Button>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        <div
          className="col-12 text-left"
          style={{
            marginTop: -5,
            paddingLeft: 20,
            paddingRight: 30,
            zIndex: 100,
          }}
        >
          <DataTable
            columns={columns}
            data={data}
            progressPending={dataPending}
            progressComponent={
              <Spinner
                className="mx-5 text-inox-green table-spinner"
                as="span"
                animation="border"
                size="lg"
                role="status"
                aria-hidden="true"
              />
            }
            noDataComponent={
              <p className="text-center table-no-data">No Data Found</p>
            }
            pagination
            highlightOnHover
            fixedHeader
            customStyles={vesselScheduleTableCustomStyles}
            dense
          />
        </div>
      </div>

      {/* -------------------- Delete Modal -------------------- */}
      <Modal
        size="sm"
        show={showDeleteModal}
        onHide={handleDeleteModalClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModalClose}>
            Close
          </Button>
          <Button
            variant="danger"
            onClick={() => deleteVesselSchedule(recordForDelete)}
          >
            {showDeleteLoader ? (
              <Spinner
                className="mx-4"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* -------------------- Update Canvas -------------------- */}
      <div
        className={
          canvasFullScreen && showUpdateCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasFullScreen && showUpdateCanvas
              ? "offcanvas offcanvas-bottom h-60 show"
              : "offcanvas offcanvas-bottom h-60"
        }
        data-bs-scroll="true"
        tabIndex="-1"
        id="updateSection"
        aria-labelledby="offcanvasBottomLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">
                Update Record
              </h4>
            </div>

            <div className="col-6">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                title="Close"
                onClick={handleUpdateModalClose}
              >
                <i className="fa fa-times text-white"></i>
              </button>

              {canvasFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => [
                    setCanvasFullScreen(false),
                    setShowUpdateCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => [
                    setCanvasFullScreen(true),
                    setShowUpdateCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="offcanvas-body">
          <div className="row" style={{ fontSize: 13 }}>
            <div className="col-12">
              <Stepper
                activeStep={activeStep}
                styleConfig={{
                  activeBgColor: "#12708C",
                  completedBgColor: "#16576b",
                }}
              >
                {steps.map((label, index) => (
                  <Step
                    label={label}
                    key={index}
                    onClick={() => {
                      if (
                        index > activeStep &&
                        (!updateVesselName ||
                          !updateVoyage ||
                          !updateVesselService)
                      )
                        return;
                      setActiveStep(index);
                    }}
                  />
                ))}
              </Stepper>
            </div>

            <div className="col-12">
              <form ref={updateform} onSubmit={(e) => updateVesselSchedule(e)}>
                {/* Step 0: Schedule Details */}
                {activeStep === 0 && (
                  <div className="row">
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label className="required-label" htmlFor="update_name">
                        Vessel Name:{" "}
                        <span className="text-danger">
                          {showUpdateNameError ? "Vessel Name is required" : ""}
                        </span>
                      </label>
                      <Select
                        options={vesselList}
                        isMulti={false}
                        isClearable
                        className="px-0"
                        placeholder="Select Vessel"
                        styles={PortSequenceSelectCustomStyles}
                        onChange={(e) => {
                          setUpdateVesselName(e);
                          setShowUpdateNameError(!e?.value);
                          setShowUpdateValidationError(false);
                          setUpdateValidationErrorArray(
                            buildUpdateErrorMessages({ updateVesselName: e }),
                          );
                        }}
                        isLoading={vesselListLoading}
                        value={updateVesselName}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label className="required-label" htmlFor="update_voyage">
                        Voyage:{" "}
                        <span className="text-danger">
                          {showUpdateVoyageError ? "Voyage is required" : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="update_voyage"
                        name="update_voyage"
                        placeholder="Enter Voyage"
                        value={updateVoyage}
                        onChange={(e) => {
                          setUpdateVoyage(e.target.value);
                          setShowUpdateVoyageError(false);
                          setShowUpdateValidationError(false);
                          setUpdateValidationErrorArray(
                            buildUpdateErrorMessages({
                              updateVoyage: e.target.value,
                            }),
                          );
                        }}
                        onBlur={(e) => {
                          setShowUpdateVoyageError(e.target.value === "");
                          setUpdateValidationErrorArray(
                            buildUpdateErrorMessages({
                              updateVoyage: e.target.value,
                            }),
                          );
                        }}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label
                        className="required-label"
                        htmlFor="update_service"
                      >
                        Service:{" "}
                        <span className="text-danger">
                          {showUpdateServiceError ? "Service is required" : ""}
                        </span>
                      </label>
                      <Select
                        options={vesselServiceList}
                        isMulti={false}
                        isClearable
                        className="px-0"
                        placeholder="Select Vessel Service"
                        styles={PortSequenceSelectCustomStyles}
                        onChange={(e) => {
                          setUpdateVesselService(e);
                          handleUpdateVesselPorts(e);
                          setShowUpdateServiceError(!e?.value);
                          setShowUpdateValidationError(false);
                          setUpdateValidationErrorArray(
                            buildUpdateErrorMessages({
                              updateVesselService: e,
                            }),
                          );
                        }}
                        isLoading={vesselServiceListLoading}
                        value={updateVesselService}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label htmlFor="update_im_number">IM Number:</label>
                      <input
                        type="text"
                        className="form-control"
                        id="update_im_number"
                        name="update_im_number"
                        placeholder="Enter IM Number"
                        value={updateImNumber}
                        onChange={(e) => setUpdateIMNumber(e.target.value)}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label htmlFor="update_im_date">IM Date:</label>
                      <input
                        type="date"
                        className="form-control"
                        id="update_im_date"
                        name="update_im_date"
                        value={updateImDate}
                        onChange={(e) => setUpdateIMDate(e.target.value)}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label htmlFor="update_imo_code">IMO Code:</label>
                      <input
                        type="text"
                        className="form-control"
                        id="update_imo_code"
                        name="update_imo_code"
                        placeholder="Enter IMO Code"
                        value={updateImoCode}
                        onChange={(e) => setUpdateImoCode(e.target.value)}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label htmlFor="update_call_sign">Call Sign:</label>
                      <input
                        type="text"
                        className="form-control"
                        id="update_call_sign"
                        name="update_call_sign"
                        placeholder="Enter Call Sign"
                        value={updateCallSign}
                        onChange={(e) => setUpdateCallSign(e.target.value)}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label htmlFor="update_line_code">Line Code:</label>
                      <input
                        type="text"
                        className="form-control"
                        id="update_line_code"
                        name="update_line_code"
                        placeholder="Enter Line Code"
                        value={updateLineCode}
                        onChange={(e) => setUpdateLineCode(e.target.value)}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label htmlFor="update_line_igm_number">
                        Line IGM Number:
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="update_line_igm_number"
                        name="update_line_igm_number"
                        placeholder="Enter Line IGM Number"
                        value={updateLineIgmNumber}
                        onChange={(e) => setUpdateLineIGMNumber(e.target.value)}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label htmlFor="update_line_igm_date">
                        Line IGM Date:
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id="update_line_igm_date"
                        name="update_line_igm_date"
                        value={updateLineIgmDate}
                        onChange={(e) => setUpdateLineIGMDate(e.target.value)}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label
                        className="required-label"
                        htmlFor="update_reserved_20ft"
                      >
                        Reserved 20Ft:{" "}
                        <span className="text-danger">
                          {showUpdateReserved20FtError
                            ? !updateReserved20Ft
                              ? "Required"
                              : "Must be a positive number"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="update_reserved_20ft"
                        name="update_reserved_20ft"
                        placeholder="Enter Reserved 20Ft"
                        min="0"
                        value={updateReserved20Ft}
                        onKeyDown={(e) => e.key === "-" && e.preventDefault()}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val === "" || isPositiveNumber(val)) {
                            setUpdateReserved20Ft(val);
                            setShowUpdateReserved20FtError(
                              !val || !isPositiveNumber(val),
                            );
                            setUpdateValidationErrorArray(
                              buildUpdateErrorMessages({
                                updateReserved20Ft: val,
                              }),
                            );
                          }
                        }}
                        onBlur={(e) => {
                          setShowUpdateReserved20FtError(
                            !e.target.value ||
                              !isPositiveNumber(e.target.value),
                          );
                          setUpdateValidationErrorArray(
                            buildUpdateErrorMessages({
                              updateReserved20Ft: e.target.value,
                            }),
                          );
                        }}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label
                        className="required-label"
                        htmlFor="update_reserved_40ft"
                      >
                        Reserved 40Ft:{" "}
                        <span className="text-danger">
                          {showUpdateReserved40FtError
                            ? !updateReserved40Ft
                              ? "Required"
                              : "Must be a positive number"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="update_reserved_40ft"
                        name="update_reserved_40ft"
                        placeholder="Enter Reserved 40Ft"
                        min="0"
                        value={updateReserved40Ft}
                        onKeyDown={(e) => e.key === "-" && e.preventDefault()}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val === "" || isPositiveNumber(val)) {
                            setUpdateReserved40Ft(val);
                            setShowUpdateReserved40FtError(
                              !val || !isPositiveNumber(val),
                            );
                            setUpdateValidationErrorArray(
                              buildUpdateErrorMessages({
                                updateReserved40Ft: val,
                              }),
                            );
                          }
                        }}
                        onBlur={(e) => {
                          setShowUpdateReserved40FtError(
                            !e.target.value ||
                              !isPositiveNumber(e.target.value),
                          );
                          setUpdateValidationErrorArray(
                            buildUpdateErrorMessages({
                              updateReserved40Ft: e.target.value,
                            }),
                          );
                        }}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label
                        className="required-label"
                        htmlFor="update_max_tonnage"
                      >
                        Max Tonnage (MT):{" "}
                        <span className="text-danger">
                          {showUpdateMaxTonnageError
                            ? !updateMaxTonnage
                              ? "Required"
                              : "Must be a positive number"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="update_max_tonnage"
                        name="update_max_tonnage"
                        placeholder="Enter Max Tonnage"
                        min="0"
                        value={updateMaxTonnage}
                        onKeyDown={(e) => e.key === "-" && e.preventDefault()}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val === "" || isPositiveNumber(val)) {
                            setUpdateMaxTonnage(val);
                            setShowUpdateMaxTonnageError(
                              !val || !isPositiveNumber(val),
                            );
                            setUpdateValidationErrorArray(
                              buildUpdateErrorMessages({
                                updateMaxTonnage: val,
                              }),
                            );
                          }
                        }}
                        onBlur={(e) => {
                          setShowUpdateMaxTonnageError(
                            !e.target.value ||
                              !isPositiveNumber(e.target.value),
                          );
                          setUpdateValidationErrorArray(
                            buildUpdateErrorMessages({
                              updateMaxTonnage: e.target.value,
                            }),
                          );
                        }}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label htmlFor="update_tba">TBA:</label>
                      <input
                        type="checkbox"
                        className="form-control form-check-input mt-2"
                        id="update_tba"
                        name="update_tba"
                        value={updateTba}
                        onChange={(e) => setUpdateTba(e.target.value)}
                      />
                    </div>
                  </div>
                )}

                {/* Step 1: Timeline */}
                {activeStep === 1 && (
                  <div
                    style={{
                      height: "400px",
                      overflowY: "auto",
                    }}
                  >
                    <div className="col-12 text-left">
                      <table className="mx-auto">
                        <thead>
                          <tr>
                            <th className="px-3 py-2">Port</th>
                            <th className="px-3 py-2">Terminal</th>
                            <th className="px-3 py-2">ETA Date</th>
                            <th className="px-3 py-2">Gate Open</th>
                            <th className="px-3 py-2">Cut Off</th>
                            <th className="px-3 py-2">ETD</th>
                          </tr>
                        </thead>
                        <tbody>
                          {updateVesselPorts.length > 0 ? (
                            updateVesselPorts?.map((port, i) => (
                              <tr key={i}>
                                <td className="px-3 py-2">
                                  {port["index"]}. {port["name"]}
                                </td>

                                <td className="px-3 py-2">
                                  <select className="form-select" disabled>
                                    <option value="">Select Terminal</option>
                                    <option
                                      key={port?.terminal_id}
                                      value={[
                                        port?.terminal_id,
                                        port?.terminal_name,
                                      ]}
                                      selected
                                    >
                                      {port?.terminal_name}
                                    </option>
                                  </select>
                                </td>

                                <td className="px-3 py-2">
                                  <input
                                    type="datetime-local"
                                    className="form-control"
                                    value={port["eta"]}
                                    onChange={(e) =>
                                      handleUpdateChange(
                                        i,
                                        "eta",
                                        e.target.value,
                                      )
                                    }
                                  />
                                </td>

                                <td className="px-3 py-2">
                                  <input
                                    type="datetime-local"
                                    className="form-control"
                                    value={port["gate_open"]}
                                    onChange={(e) =>
                                      handleUpdateChange(
                                        i,
                                        "gate_open",
                                        e.target.value,
                                      )
                                    }
                                  />
                                </td>

                                <td className="px-3 py-2">
                                  <input
                                    type="datetime-local"
                                    className="form-control"
                                    value={port["cut_off"]}
                                    onChange={(e) =>
                                      handleUpdateChange(
                                        i,
                                        "cut_off",
                                        e.target.value,
                                      )
                                    }
                                  />
                                </td>

                                <td className="px-3 py-2">
                                  <input
                                    type="datetime-local"
                                    className="form-control"
                                    value={port["etd"]}
                                    onChange={(e) =>
                                      handleUpdateChange(
                                        i,
                                        "etd",
                                        e.target.value,
                                      )
                                    }
                                  />
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td className="text-center" colSpan={6}>
                                No Timeline Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </form>
            </div>

            <div
              className={`form-group ${canvasFullScreen ? "col-md-12" : "col-md-12"}`}
            >
              <span
                className="btn btn-inox-green border-0"
                style={{ width: 200, marginRight: 10 }}
                onClick={() => setActiveStep((prev) => Math.max(prev - 1, 0))}
                disabled={activeStep === 0}
              >
                Back
              </span>

              {activeStep === 1 ? (
                <>
                  <Button
                    type="button"
                    className="btn btn-inox-green border-0 canvas-button"
                    style={{ width: 180, marginTop: 20 }}
                    onClick={updateVesselSchedule}
                    disabled={
                      buildUpdateErrorMessages().length > 0 || showUpdateLoader
                    }
                  >
                    {showUpdateLoader ? (
                      <Spinner
                        className="mx-4"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <>
                        <i className="fa fa-save"></i>
                        <span className="mx-2">Update Schedule</span>
                      </>
                    )}
                  </Button>

                  {buildUpdateErrorMessages().length > 0 && (
                    <div className="error-tooltip-wrapper">
                      <Button
                        style={{
                          backgroundColor: "#C21E22",
                          border: "#f82e2e",
                        }}
                        title="Show Errors"
                        className="mx-2"
                        onClick={handleUpdateCheckValidationClick}
                        onMouseLeave={() =>
                          setIsUpdateValidationErrorVisible(false)
                        }
                      >
                        <i className="fa fa-exclamation"></i>
                      </Button>
                      {isUpdateValidationErrorVisible && (
                        <div className="validation-error-tooltip">
                          <ul className="mb-0 px-4">
                            {buildUpdateErrorMessages().map((error, index) => (
                              <li key={index} className="text-left small pb-0">
                                {error}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                </>
              ) : (
                <span
                  className="btn btn-inox-green border-0"
                  style={{ width: 200 }}
                  onClick={() => {
                    setShowUpdateNameError(!updateVesselName);
                    setShowUpdateVoyageError(!updateVoyage);
                    setShowUpdateServiceError(!updateVesselService);
                    setShowUpdateReserved20FtError(
                      !updateReserved20Ft ||
                        !isPositiveNumber(updateReserved20Ft),
                    );
                    setShowUpdateReserved40FtError(
                      !updateReserved40Ft ||
                        !isPositiveNumber(updateReserved40Ft),
                    );
                    setShowUpdateMaxTonnageError(
                      !updateMaxTonnage || !isPositiveNumber(updateMaxTonnage),
                    );
                    setActiveStep((prev) =>
                      Math.min(prev + 1, steps.length - 1),
                    );
                  }}
                >
                  Next
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* -------------------- End Update Canvas -------------------- */}

      {/* -------------------- Add Canvas -------------------- */}
      <div
        className={
          canvasFullScreen && showAddCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasFullScreen && showAddCanvas
              ? "offcanvas offcanvas-bottom h-60 show"
              : "offcanvas offcanvas-bottom h-60"
        }
        data-bs-scroll="true"
        tabIndex="-1"
        id="addSection"
        aria-labelledby="offcanvasBottomLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">
                Add New Record
              </h4>
            </div>

            <div className="col-6">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                title="Close"
                onClick={handleAddModalClose}
              >
                <i className="fa fa-times text-white"></i>
              </button>

              {canvasFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => [
                    setCanvasFullScreen(false),
                    setShowAddCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => [
                    setCanvasFullScreen(true),
                    setShowAddCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="offcanvas-body">
          <div className="row" style={{ fontSize: 13 }}>
            <div className="col-12">
              <Stepper
                activeStep={activeStep}
                styleConfig={{
                  activeBgColor: "#12708C",
                  completedBgColor: "#16576b",
                }}
              >
                {steps.map((label, index) => (
                  <Step
                    label={label}
                    key={index}
                    onClick={() => {
                      if (
                        index > activeStep &&
                        (!vesselName || !voyage || !vesselService)
                      )
                        return;
                      setActiveStep(index);
                    }}
                  />
                ))}
              </Stepper>
            </div>

            <div className="col-12">
              <form ref={addform} onSubmit={(e) => addVesselSchedule(e)}>
                {/* Step 0: Schedule Details */}
                {activeStep === 0 && (
                  <div className="row">
                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label className="required-label" htmlFor="add_name">
                        Vessel Name:{" "}
                        <span className="text-danger">
                          {showNameError ? "Vessel Name is required" : ""}
                        </span>
                      </label>
                      <Select
                        options={vesselList}
                        isMulti={false}
                        isClearable
                        className="px-0"
                        placeholder="Select Vessel"
                        styles={PortSequenceSelectCustomStyles}
                        onChange={(e) => {
                          setVesselName(e);
                          setShowNameError(!e?.value);
                          setShowValidationError(false);
                          setValidationErrorArray(
                            buildAddErrorMessages({ vesselName: e }),
                          );
                        }}
                        isLoading={vesselListLoading}
                        value={vesselName}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label className="required-label" htmlFor="add_voyage">
                        Voyage:{" "}
                        <span className="text-danger">
                          {showVoyageError ? "Voyage is required" : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="add_voyage"
                        name="add_voyage"
                        placeholder="Enter Voyage"
                        value={voyage}
                        onChange={(e) => {
                          setVoyage(e.target.value);
                          setShowVoyageError(false);
                          setShowValidationError(false);
                          setValidationErrorArray(
                            buildAddErrorMessages({ voyage: e.target.value }),
                          );
                        }}
                        onBlur={(e) => {
                          setShowVoyageError(e.target.value === "");
                          setValidationErrorArray(
                            buildAddErrorMessages({ voyage: e.target.value }),
                          );
                        }}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label className="required-label" htmlFor="add_service">
                        Service:{" "}
                        <span className="text-danger">
                          {showServiceError ? "Service is required" : ""}
                        </span>
                      </label>
                      <Select
                        options={vesselServiceList}
                        isMulti={false}
                        isClearable
                        className="px-0"
                        placeholder="Select Vessel Service"
                        styles={PortSequenceSelectCustomStyles}
                        onChange={(e) => {
                          setVesselService(e);
                          handleVesselPorts(e);
                          setShowServiceError(!e?.value);
                          setShowValidationError(false);
                          setValidationErrorArray(
                            buildAddErrorMessages({ vesselService: e }),
                          );
                        }}
                        isLoading={vesselServiceListLoading}
                        value={vesselService}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label htmlFor="add_im_number">IM Number:</label>
                      <input
                        type="text"
                        className="form-control"
                        id="add_im_number"
                        name="add_im_number"
                        placeholder="Enter IM Number"
                        value={imNumber}
                        onChange={(e) => setIMNumber(e.target.value)}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label htmlFor="add_im_date">IM Date:</label>
                      <input
                        type="date"
                        className="form-control"
                        id="add_im_date"
                        name="add_im_date"
                        value={imDate}
                        onChange={(e) => setIMDate(e.target.value)}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label htmlFor="add_imo_code">IMO Code:</label>
                      <input
                        type="text"
                        className="form-control"
                        id="add_imo_code"
                        name="add_imo_code"
                        placeholder="Enter IMO Code"
                        value={imoCode}
                        onChange={(e) => setImoCode(e.target.value)}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label htmlFor="add_call_sign">Call Sign:</label>
                      <input
                        type="text"
                        className="form-control"
                        id="add_call_sign"
                        name="add_call_sign"
                        placeholder="Enter Call Sign"
                        value={callSign}
                        onChange={(e) => setCallSign(e.target.value)}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label htmlFor="add_line_code">Line Code:</label>
                      <input
                        type="text"
                        className="form-control"
                        id="add_line_code"
                        name="add_line_code"
                        placeholder="Enter Line Code"
                        value={lineCode}
                        onChange={(e) => setLineCode(e.target.value)}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label htmlFor="add_line_igm_number">
                        Line IGM Number:
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="add_line_igm_number"
                        name="add_line_igm_number"
                        placeholder="Enter Line IGM Number"
                        value={lineIgmNumber}
                        onChange={(e) => setLineIGMNumber(e.target.value)}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label htmlFor="add_line_igm_date">Line IGM Date:</label>
                      <input
                        type="date"
                        className="form-control"
                        id="add_line_igm_date"
                        name="add_line_igm_date"
                        value={lineIgmDate}
                        onChange={(e) => setLineIGMDate(e.target.value)}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label
                        className="required-label"
                        htmlFor="add_reserved_20ft"
                      >
                        Reserved 20Ft:{" "}
                        <span className="text-danger">
                          {showReserved20FtError
                            ? !reserved20Ft
                              ? "Required"
                              : "Must be a positive number"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="add_reserved_20ft"
                        name="add_reserved_20ft"
                        placeholder="Enter Reserved 20Ft"
                        min="0"
                        value={reserved20Ft}
                        onKeyDown={(e) => e.key === "-" && e.preventDefault()}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val === "" || isPositiveNumber(val)) {
                            setReserved20Ft(val);
                            setShowReserved20FtError(
                              !val || !isPositiveNumber(val),
                            );
                            setValidationErrorArray(
                              buildAddErrorMessages({ reserved20Ft: val }),
                            );
                          }
                        }}
                        onBlur={(e) => {
                          setShowReserved20FtError(
                            !e.target.value ||
                              !isPositiveNumber(e.target.value),
                          );
                          setValidationErrorArray(
                            buildAddErrorMessages({
                              reserved20Ft: e.target.value,
                            }),
                          );
                        }}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label
                        className="required-label"
                        htmlFor="add_reserved_40ft"
                      >
                        Reserved 40Ft:{" "}
                        <span className="text-danger">
                          {showReserved40FtError
                            ? !reserved40Ft
                              ? "Required"
                              : "Must be a positive number"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="add_reserved_40ft"
                        name="add_reserved_40ft"
                        placeholder="Enter Reserved 40Ft"
                        min="0"
                        value={reserved40Ft}
                        onKeyDown={(e) => e.key === "-" && e.preventDefault()}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val === "" || isPositiveNumber(val)) {
                            setReserved40Ft(val);
                            setShowReserved40FtError(
                              !val || !isPositiveNumber(val),
                            );
                            setValidationErrorArray(
                              buildAddErrorMessages({ reserved40Ft: val }),
                            );
                          }
                        }}
                        onBlur={(e) => {
                          setShowReserved40FtError(
                            !e.target.value ||
                              !isPositiveNumber(e.target.value),
                          );
                          setValidationErrorArray(
                            buildAddErrorMessages({
                              reserved40Ft: e.target.value,
                            }),
                          );
                        }}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label
                        className="required-label"
                        htmlFor="add_max_tonnage"
                      >
                        Max Tonnage (MT):{" "}
                        <span className="text-danger">
                          {showMaxTonnageError
                            ? !maxTonnage
                              ? "Required"
                              : "Must be a positive number"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="add_max_tonnage"
                        name="add_max_tonnage"
                        placeholder="Enter Max Tonnage"
                        min="0"
                        value={maxTonnage}
                        onKeyDown={(e) => e.key === "-" && e.preventDefault()}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val === "" || isPositiveNumber(val)) {
                            setMaxTonnage(val);
                            setShowMaxTonnageError(
                              !val || !isPositiveNumber(val),
                            );
                            setValidationErrorArray(
                              buildAddErrorMessages({ maxTonnage: val }),
                            );
                          }
                        }}
                        onBlur={(e) => {
                          setShowMaxTonnageError(
                            !e.target.value ||
                              !isPositiveNumber(e.target.value),
                          );
                          setValidationErrorArray(
                            buildAddErrorMessages({
                              maxTonnage: e.target.value,
                            }),
                          );
                        }}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label htmlFor="add_tba">TBA:</label>
                      <input
                        type="checkbox"
                        className="form-control form-check-input mt-2"
                        id="add_tba"
                        name="add_tba"
                        value={tba}
                        onChange={(e) => setTba(e.target.value)}
                      />
                    </div>
                  </div>
                )}

                {/* Step 1: Timeline */}
                {activeStep === 1 && (
                  <div
                    style={{
                      height: "400px",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    <div className="col-12 text-left">
                      <table className="mx-auto">
                        <thead>
                          <tr>
                            <th className="px-3 py-2">Port</th>
                            <th className="px-3 py-2">Terminal</th>
                            <th className="px-3 py-2">ETA Date</th>
                            <th className="px-3 py-2">Gate Open</th>
                            <th className="px-3 py-2">Cut Off</th>
                            <th className="px-3 py-2">ETD</th>
                          </tr>
                        </thead>
                        <tbody>
                          {vesselPorts?.map((port, i) => (
                            <tr key={i}>
                              <td className="px-3 py-2">
                                {port["index"]}. {port["name"]}
                              </td>

                              <td className="px-3 py-2">
                                <select className="form-select" disabled>
                                  <option value="">Select Terminal</option>
                                  <option
                                    key={port?.terminal_id}
                                    value={[
                                      port?.terminal_id,
                                      port?.terminal_name,
                                    ]}
                                    selected
                                  >
                                    {port?.terminal_name}
                                  </option>
                                </select>
                              </td>

                              <td className="px-3 py-2">
                                <input
                                  type="datetime-local"
                                  className="form-control"
                                  onChange={(e) =>
                                    handleChange(i, "eta", e.target.value)
                                  }
                                />
                              </td>

                              <td className="px-3 py-2">
                                <input
                                  type="datetime-local"
                                  className="form-control"
                                  onChange={(e) =>
                                    handleChange(i, "gate_open", e.target.value)
                                  }
                                />
                              </td>

                              <td className="px-3 py-2">
                                <input
                                  type="datetime-local"
                                  className="form-control"
                                  onChange={(e) =>
                                    handleChange(i, "cut_off", e.target.value)
                                  }
                                />
                              </td>

                              <td className="px-3 py-2">
                                <input
                                  type="datetime-local"
                                  className="form-control"
                                  onChange={(e) =>
                                    handleChange(i, "etd", e.target.value)
                                  }
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </form>
            </div>

            <div
              className={`form-group ${canvasFullScreen ? "col-md-12" : "col-md-12"}`}
            >
              <span
                className="btn btn-inox-green border-0"
                style={{ width: 200, marginRight: 10 }}
                onClick={() => setActiveStep((prev) => Math.max(prev - 1, 0))}
                disabled={activeStep === 0}
              >
                Back
              </span>

              {activeStep === 1 ? (
                <>
                  <Button
                    type="button"
                    className="btn btn-inox-green border-0 canvas-button"
                    style={{ width: 180, marginTop: 20 }}
                    onClick={addVesselSchedule}
                    disabled={
                      buildAddErrorMessages().length > 0 || showAddLoader
                    }
                  >
                    {showAddLoader ? (
                      <Spinner
                        className="mx-4"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <>
                        <i className="fa fa-plus"></i>
                        <span className="mx-2">Add Schedule</span>
                      </>
                    )}
                  </Button>

                  {buildAddErrorMessages().length > 0 && (
                    <div className="error-tooltip-wrapper">
                      <Button
                        style={{
                          backgroundColor: "#C21E22",
                          border: "#f82e2e",
                        }}
                        title="Show Errors"
                        className="mx-2"
                        onClick={handleCheckValidationClick}
                        onMouseLeave={() => setIsValidationErrorVisible(false)}
                      >
                        <i className="fa fa-exclamation"></i>
                      </Button>
                      {isValidationErrorVisible && (
                        <div className="validation-error-tooltip">
                          <ul className="mb-0 px-4">
                            {buildAddErrorMessages().map((error, index) => (
                              <li key={index} className="text-left small pb-0">
                                {error}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                </>
              ) : (
                <span
                  className="btn btn-inox-green border-0"
                  style={{ width: 200 }}
                  onClick={() => {
                    setShowNameError(!vesselName);
                    setShowVoyageError(!voyage);
                    setShowServiceError(!vesselService);
                    setShowReserved20FtError(
                      !reserved20Ft || !isPositiveNumber(reserved20Ft),
                    );
                    setShowReserved40FtError(
                      !reserved40Ft || !isPositiveNumber(reserved40Ft),
                    );
                    setShowMaxTonnageError(
                      !maxTonnage || !isPositiveNumber(maxTonnage),
                    );
                    setActiveStep((prev) =>
                      Math.min(prev + 1, steps.length - 1),
                    );
                  }}
                >
                  Next
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* -------------------- End Add Canvas -------------------- */}
    </div>
  );
}

export default VesselScheduleMaster;
